import React, { useEffect, useRef, useState, Suspense, lazy } from 'react';
import { useLocation } from 'react-router-dom';
import { HelpCircle } from 'lucide-react';
import { OPEN_HELP, topicsForPath } from '../help/contextMap';

// "Help for this page": a small button that opens the matching Help Center
// topic in a side panel without leaving the page. The panel (and the topic
// text) is loaded only when it is opened.
const HelpPanel = lazy(() => import('./HelpPanel'));

const HelpLauncher = () => {
    const { pathname } = useLocation();
    const [open, setOpen] = useState(false);
    const button = useRef(null);
    const slugs = topicsForPath(pathname);

    useEffect(() => { setOpen(false); }, [pathname]); // navigating away closes it
    useEffect(() => {
        const onOpen = () => setOpen(true);
        window.addEventListener(OPEN_HELP, onOpen);
        return () => window.removeEventListener(OPEN_HELP, onOpen);
    }, []);

    if (!slugs.length) return null;
    return (
        <>
            <button ref={button} type="button" aria-label="Help for this page" aria-haspopup="dialog" aria-expanded={open} onClick={() => setOpen(true)}
                style={{ position: 'fixed', left: 20, bottom: 20, zIndex: 40, width: 44, height: 44, borderRadius: '50%', border: '1px solid var(--border)', background: 'var(--surface)', color: 'var(--primary)', cursor: 'pointer', display: 'flex', alignItems: 'center', justifyContent: 'center', boxShadow: '0 4px 12px rgba(0,0,0,0.25)' }}>
                <HelpCircle size={22} />
            </button>
            {open && (
                <Suspense fallback={null}>
                    <HelpPanel slugs={slugs} onClose={() => { setOpen(false); button.current?.focus(); }} />
                </Suspense>
            )}
        </>
    );
};

export default HelpLauncher;
